// @flow
export const documentFormatExtension =
  'png|jpg|gif|pdf|jpeg|doc|dot|docx|dotx|docm|dotm|xls|xlt|xla|xlsx|xltx|xlsm|xltm|xlam|xlsb|ppt|pot|pps|ppa|pptx|potx|ppsx|ppam|pptm|potm|ppsm|mdb';
export const imageFormatExtension = 'png|jpg|gif|jpeg';
